export const environment = {
  production: true,
  baseUrl: 'https://api.prod.medintia.com/graphql',
  apiUrl: 'https://api.prod.medintia.com/api',
  fileUrls: 'https://5iab2c9vof.execute-api.us-east-1.amazonaws.com/prod/files',
  apiKey: 'ujTaIH17HrJMFy4u2Jcs5NVQPlqHmEKRWcMNi400',
  attentionAttachment: 'https://api.prod.medintia.com/api/media/upload',
  medicalChatbot: 'https://5iab2c9vof.execute-api.us-east-1.amazonaws.com/prod/medical_assistant',
  billingApiUrl: 'https://billing-api.prod.medintia.com/api/v1',
  billingApiKey: 'ciNoNY4XWfeGgWqsYEvhOf9B2dLd2y3JKMz2seiPL71c1BLVl1mCG5Z5FsaGoGQWOtmUbtcfOjYkK5pw',
  fevDefaults: {
    softwareId: '',
    testSetId: '',
    countryId: 46,
    taxId: 1,
    merchantRegistration: ''
  }

};
